<template>
  <div class="info">
    <h3 style="padding:0px 30px;">个人信息</h3>
    <!-- 个人信息 -->
    <el-form :model="formInfoData" :rules="rules" label-width="200px">
      <el-form-item label="角色：">
        <span>{{formInfoData.roleName}}</span>
      </el-form-item>
      <el-form-item label="手机：">
        <!-- <el-input v-model="formInfoData.mobile"></el-input> -->
        <span>{{formInfoData.mobile || '暂无'}}</span>

        <span class="ml">
          <router-link to="/changephone">修改/添加手机号</router-link>
          <!-- <el-button v-if="isMobile" @click="isMobile = !isMobile" type="text">添加/修改手机号</el-button> -->
        </span>
      </el-form-item>
      <el-form-item label="邮箱：">
        <span>{{formInfoData.email}}</span>
        <span class="ml">
          <router-link to="/changeemail">修改/添加邮箱</router-link>
        </span>
      </el-form-item>
      <el-form-item label="用户名：">
        <el-input v-model="formInfoData.username"></el-input>
      </el-form-item>
      <el-form-item label="真实姓名：">
        <el-input v-model="formInfoData.truename"></el-input>
      </el-form-item>
      <!-- <el-form-item label="登录密码：">
        <el-input type="password" v-model="formInfoData.password" clearable></el-input>
        <div class="f12" style="color:red;">注：如不修改密码请留空</div>
      </el-form-item>-->
      <el-form-item label="性别：">
        <el-radio-group v-model="isRadio" @change="selectRadio">
          <el-radio-button label="男"></el-radio-button>
          <el-radio-button label="女"></el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="职务：">
        <el-input v-model="formInfoData.position"></el-input>
      </el-form-item>
      <el-form-item label="简介：">
        <el-input v-model="formInfoData.intro" type="textarea" :rows="5"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="saveInfos" type="primary">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      isMobile: true,
      formInfoData: {},
      isRadio: "男",
      rules: {
        truename: [
          { required: true, message: "请输入真实姓名", trigger: "blur" }
        ],
        code: [{ required: true, message: "请输入邮箱验证码", trigger: "blur" }]
      }
    };
  },
  methods: {
    // 获取个人信息
    getUserInfos: async function() {
      var res = await this.$http.get(`/v1/userInfo/getUserInfo`);
      var { code, data, message } = res.data;
      if (code == 0) {
        this.formInfoData = data;
        this.$store.state.userInfo = data;
        console.log(this.formInfoData);
        this.isRadio = data.sex == "F" ? "女" : "男";
      } else if (code == 40100) {
        this.$message.error(message);
        this.$router.push("/login");
      } else {
        this.$message.error(message);
      }
    },
    // 选择性别
    selectRadio: function() {
      this.formInfoData.sex = this.isRadio == "女" ? "F" : "M";
      console.log(this.isRadio);
    },
    // 保存信息
    saveInfos: function() {
      this.$confirm("是否提交保存资料？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var res = await this.$http.post(
            "/v1/busUser/saveOrUpdateUser",
            this.formInfoData
          );
          var { code, message, data } = res.data;
          if (code == 0) {
            this.$message.success("修改个人资料成功。");
          } else {
            this.$message.error(message);
          }
        })
        .catch(() => {});
    }
  },
  mounted: function() {
    this.getUserInfos();
  }
};
</script>

<style scoped lang="scss">
.tal {
  text-align: left;
}
.tar {
  text-align: right;
}
.info {
  margin: 0 auto;
  .el-input,
  .el-textarea {
    width: 600px;
  }

  a {
    font-size: 12px;
    text-decoration: underline red;
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/personalcenter/common/personalinfo.vue